import { fabric } from 'fabric';
import { modifyState } from '~src/state';

export const initPreviewCanvas = ({ width, height }) => {
  const previewCanvas = new fabric.StaticCanvas('preview-canvas', {
    width,
    height,
  });

  modifyState('previewCanvas', previewCanvas);
};
